import React, { Component } from 'react';
import { connect } from 'react-redux';
class BookSection extends Component {

    constructor(props) {
        super(props);
        this.section = props.section;
        this.section_name = props.section_name;
        this.section = props.section;
        this.section_slug = props.section_slug;
    }

    decodeHtmlEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    render() {
        // Group books by sub-categories
        const booksBySubCategory = {};
        const booksWithoutSubCategory = [];

        this.section.filter((book) => {
            if (this.props.document_type_filter.length > 0) {
                return this.props.document_type_filter.includes(book.document_types.slug);
            }
            return true;
        }).forEach((book) => {
            if (book.sub_categories && book.sub_categories.length > 0) {
                const subCatName = book.sub_categories[0].name;
                if (!booksBySubCategory[subCatName]) {
                    booksBySubCategory[subCatName] = [];
                }
                booksBySubCategory[subCatName].push(book);
            } else {
                booksWithoutSubCategory.push(book);
            }
        });

        // Sort books without subcategories
        booksWithoutSubCategory.sort((a, b) => {
            const aStartsWithNumber = /^\d/.test(a.title);
            const bStartsWithNumber = /^\d/.test(b.title);
            
            if (aStartsWithNumber && bStartsWithNumber) {
                // Both start with numbers - sort in descending order
                return b.title.localeCompare(a.title);
            } else if (!aStartsWithNumber && !bStartsWithNumber) {
                // Both start with letters - sort in ascending order
                return a.title.localeCompare(b.title);
            } else {
                // Mixed case - put numbers first in descending order
                return aStartsWithNumber ? -1 : 1;
            }
        });

        // Sort books within each subcategory
        Object.keys(booksBySubCategory).forEach(subCat => {
            booksBySubCategory[subCat].sort((a, b) => {
                const aStartsWithNumber = /^\d/.test(a.title);
                const bStartsWithNumber = /^\d/.test(b.title);
                
                if (aStartsWithNumber && bStartsWithNumber) {
                    // Both start with numbers - sort in descending order
                    return b.title.localeCompare(a.title);
                } else if (!aStartsWithNumber && !bStartsWithNumber) {
                    // Both start with letters - sort in ascending order
                    return a.title.localeCompare(b.title);
                } else {
                    // Mixed case - put numbers first in descending order
                    return aStartsWithNumber ? -1 : 1;
                }
            });
        });

        return (
            <section id={`jump-${this.section_slug}`} class="anchor-target section-title">
                <h2 class="section-title__heading-gold"><span>{this.section_name}</span></h2>
                <div class="section-title__divider"></div>
                <a href="#book-catalog-anchors" class="btn-anchor-to-top">
                    <span class="glyphicon glyphicon-circle-arrow-up" aria-hidden="true"></span>
                    Back to Top
                </a>
                <a href="#book-catalog-anchors" class="btn-show-categories">
                    <span class="glyphicon glyphicon-circle-arrow-up" aria-hidden="true"></span>
                    Back to Categories
                </a>
                <div class="catalog-content-section">
                    {/* Render books without sub-categories first */}
                    {booksWithoutSubCategory.map((book) => (
                        <p className={book.class} key={book.permalink}>
                            <a href={book.permalink}>{this.decodeHtmlEntities(book.title)}</a>
                            {book.kinetix_code && <a href={book.kinetix_link}><img class="alignnone size-full wp-image-951731" src={book.kinetix_image} alt="" width="181" height="27"/></a>}
                            {book.is_on_isda_create && <a href={book.isda_create_link}><img class="alignnone size-full wp-image-951731" src={book.isda_create_image} alt="" width="150" height="32"/></a>}
                        </p>
                    ))}
                    
                    {/* Render sub-category sections */}
                    {Object.entries(booksBySubCategory)
                        .sort(([a], [b]) => a.localeCompare(b))
                        .map(([subCategoryName, books]) => (
                        <div key={subCategoryName} className="sub-category-section">
                            <section id={`jump-${this.section_slug}-${subCategoryName.toLowerCase().replace(/\s+/g, '-')}`}>
                                <h4 className="sub-category-title">{this.decodeHtmlEntities(subCategoryName)}</h4>
                                {books.map((book) => (
                                    <p className={book.class} key={book.permalink}>
                                        <a href={book.permalink}>{this.decodeHtmlEntities(book.title)}</a>
                                        {book.kinetix_code && <a href={book.kinetix_link}><img class="alignnone size-full wp-image-951731" src={book.kinetix_image} alt="" width="181" height="27"/></a>}
                                        {book.is_on_isda_create && <a href={book.isda_create_link}><img class="alignnone size-full wp-image-951731" src={book.isda_create_image} alt="" width="150" height="32"/></a>}
                                    </p>
                                ))}
                            </section>
                        </div>
                    ))}
                </div>
            </section>
        );
    }
}

function mapStateToProps( { document_type_filter } ) {
	return {
		document_type_filter
	};
};  

export default connect(mapStateToProps)(BookSection);